/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { createLOG2E } from '../../factoriesAny.js';
export var LOG2EDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  createLOG2E: createLOG2E
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesLOG2E.generated.js
// module id = 1439
// module chunks = 0